import React, { Component } from "react";
import axios from "axios";
import "./App.scss";
import MainMenu from "./components/MainMenu";
import AddLocations from "./components/AddLocations";
import Compare from "./components/Compare";
import About from "./components/About";
import Map from "./components/Map";

import { BrowserRouter as Router, Route, Link, Switch } from "react-router-dom";

class App extends Component {
  constructor(props) {
    super(props);
    this.state = {
      searchTerm: "London",
      value: "",
      cityListData: [],
      cityLabelsArr: [],
      items: [],
      cityfound: true,
      inputClassName: "",
      alertVisible: false,
      formMsg: "",
      selectedID: "",
      formResponse: "",
      dataLoaded: false
    };
    this.checkCityData = this.checkCityData.bind(this);
    this.loadCityData = this.loadCityData.bind(this);
    this.loadCityForecast = this.loadCityForecast.bind(this);
    this.checkCityTest = this.checkCityTest.bind(this);
    this.checkDelete = this.checkDelete.bind(this);
    this.setMaxTemp = this.setMaxTemp(this);
  }

  setMaxTemp(tempValue) {
    this.setState({ maxTempAllLocations: tempValue });
  }

  checkDelete(id) {
    this.setState({ selectedID: id });
    this.setState(prevState => ({
      items: prevState.items.filter(el => el != id)
    }));
    //console.log(JSON.stringify(id));
    //delete(id);
  }

  checkCityTest(cityName) {
    //alert("CITYNAME: " + cityName);
    this.setState({ searchTerm: cityName });
    this.setState(
      {
        searchTerm: cityName
      },
      () => {
        this.checkCityData();
      }
    );
  }

  checkCityData() {
    let cityfound = false;
    console.log("event.target.searchTerm: " + this.state.searchTerm);
    console.log("this.state.items.length: " + this.state.items.length);
    if (this.state.items.length == 0) {
      //alert("list is empty!!");
      this.loadCityData();
    } else {
      for (let i = 0; i < this.state.items.length; i++) {
        if (
          this.state.items[i].name.toLowerCase() ===
          this.state.searchTerm.toLowerCase()
        ) {
          cityfound = true;
          //alert("city ALREADY in List");
        }
      }

      if (cityfound) {
        //alert("city ALREADY in List");
        //this.setState({ visible: true });
        this.setState(state => ({
          cityfound: false,
          alertVisible: true,
          formMsg: this.state.searchTerm + " is already added"
        }));
      } else {
        //alert("ADD CITY ");
        this.setState(state => ({
          cityfound: true,
          value: "",
          searchTerm: ""
        }));
        this.loadCityData();
      }
    }
    //this.secondaryFun();
  }

  loadCityData() {
    console.log("loadCityData!!! ");

    axios
      .get(
        "http://api.openweathermap.org/data/2.5/weather?q=" +
          this.state.searchTerm +
          ",uk&units=metric&APPID=f75dbca3857efe878dde6338a5a3aa7d"
      )
      //.get(`api.openweathermap.org/data/2.5/find?q=London&units=metric`)
      .then(res => {
        console.log("CITY DATA +++++++++++");
        console.log(res.data);
        console.log("CITY DATA +++++++++++");
        const tempData = {};
        const allWeather = res.data;

        tempData.name = allWeather.name;
        tempData.id = allWeather.id;
        tempData.forecasts = [];
        tempData.latitude = allWeather.coord.lat;
        tempData.longitude = allWeather.coord.lon;

        Object.keys(allWeather.main).map(key => {
          console.log(
            "THE KEY IS: " + key + " the value is:" + allWeather.main[key]
          );
          tempData[key] = allWeather.main[key];
        });
        tempData.description = allWeather.weather[0].description;
        tempData.icon = allWeather.weather[0].icon;
        tempData.weatherID = allWeather.weather[0].id;

        tempData.windSpeed = allWeather.wind.speed;
        tempData.windDeg = allWeather.wind.deg;

        this.setState({ items: this.state.items.concat([tempData]) }, () =>
          this.loadCityForecast(tempData.id)
        );
      });
    console.log("itemds ARR: " + this.state.items);
  } // END LOAD CITY DATA

  loadCityForecast(cityID) {
    //alert("cityID= " + cityID);
    axios
      .get(
        "http://api.openweathermap.org/data/2.5/forecast?id=" +
          cityID +
          "&units=metric&APPID=f75dbca3857efe878dde6338a5a3aa7d"
      )
      //.get(`api.openweathermap.org/data/2.5/find?q=London&units=metric`)
      .then(res => {
        //console.log("FORECAST RESULT: " + JSON.stringify(res));
        const forecasts = [];
        res.data.list.map(item => {
          const tempitem = {};

          tempitem.dt_txt = item.dt_txt;
          tempitem.dt = item.dt;

          Object.keys(item.main).map(key => {
            tempitem[key] = item.main[key];
          });

          tempitem.description = item.weather[0].description;
          tempitem.weatherID = item.weather[0].id;
          tempitem.icon = item.weather[0].icon;
          tempitem.windSpeed = item.wind.speed;
          tempitem.windDeg = item.wind.deg;

          forecasts.push(tempitem);

          //tempData[key] = allWeather.main[key];
        });

        // SEARCH FOR THIS ID in items  & add forecasts to it
        console.log("res.data.list.length = " + res.data.list.length);
        console.log("MY FORECASTS ARR LENGTH: " + forecasts.length);

        //console.log("MY FORECASTS ARR : " + JSON.stringify(forecasts, null, 2));

        this.setState(state => {
          const items = state.items.map(
            item => {
              if (cityID === item.id) {
                return { ...item, forecasts: forecasts };
              } else {
                return item;
              }
            },
            () => {
              this.setState({ dataLoaded: true });
            }
          );

          return {
            items
          };
        });
      });
    this.setState({ dataLoaded: true });
  }

  // END loadCityForecast

  delete(id) {
    //alert("ID IS: " + JSON.stringify(id));
    this.setState(prevState => ({
      items: prevState.items.filter(el => el != id)
    }));
  }

  componentDidMount() {
    document.body.classList.toggle("landing-page");
    this.checkCityData();
  }

  render() {
    return (
      <Router basename="/weatherornot">
        <div className="App">
          <MainMenu />
          <div>
            <Switch>
              <Route
                path="/"
                exact
                render={props => (
                  <AddLocations
                    {...props}
                    checkCityTest={this.checkCityTest}
                    items={this.state.items}
                    checkDelete={this.checkDelete}
                    formResponse={this.state.formResponse}
                    formMsg={this.state.formMsg}
                  />
                )}
              />

              <Route
                path="/compare"
                exact
                render={props => (
                  <Compare
                    {...props}
                    //checkCityTest={this.checkCityTest}
                    items={this.state.items}
                    dataLoaded={this.state.dataLoaded}

                    //checkDelete={this.checkDelete}
                  />
                )}
              />
              {/*}
            <Route path="/compare" component={Compare} />
            */}
              <Route path="/about" component={About} />
            </Switch>
          </div>
          <Map items={this.state.items} />
        </div>
      </Router>
    );
  }
}

export default App;
